/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import Swal from "sweetalert2"
import { CircularProgress, Tooltip } from "@material-ui/core"
import { getRequest, putRequest } from "utils/request"
import { format } from "date-fns"
import { DataTable } from "primereact/datatable"

import Imports from "./Imports"
import Exports from "./Exports"

import "./style.css"

import { Column } from "primereact/column"

import { i18n, translate } from "../../translate/i18n"
import { useNotification } from "hooks/notification"
import { useModal } from "hooks/modal"
import Paginator from "../../components/Paginator"
import { SendWhatsappMsgToCustomer } from "./components/SendWhatsappMsgToCustomer"

export default function Customers({ history }) {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [update, setUpdate] = useState(0)
  const [totalCustomers, setTotalCustomers] = useState(0)
  const [linkModelo, setlinkModelo] = useState("")
  const [filter, setFilter] = useState("")
  const [showImportList, setShowImportList] = useState(false)
  const [showExportList, setShowExportList] = useState(false)
  const [onlyActive, setOnlyActive] = useState(true)
  const [onlyInactive, setOnlyInactive] = useState(false)
  const [pagination, setPagination] = useState({
    first: 0,
    rows: 25,
    page: 1,
  })

  const { toggleHelperId } = useModal()

  const { selectedCompany } = useNotification()

  const handlePageChange = (pageNumber, itemsPerPage) => {
    setPagination({
      ...pagination,
      page: pageNumber,
      rows: itemsPerPage,
      first: pageNumber * itemsPerPage,
    })
    loadMore((pageNumber - 1) * itemsPerPage, itemsPerPage)
  }
  //DATATABLE TEMPLATES
  const loadMore = async (pageNumber, itemsPerPage) => {
    setLoadingMore(true)
    const ReturnGet3 = await getRequest(
      `/customers?CompanyId=${
        selectedCompany.id
      }&offset=${pageNumber}&limit=${itemsPerPage}&text=${filter}&onlyActive=${
        onlyActive ? 1 : 0
      }&onlyInactive=${onlyInactive ? 1 : 0}`
    )
    if (ReturnGet3.success) {
      ReturnGet3.data.data.forEach((e) => {
        if (e.active) {
          e.active = i18n.t("userActive")
        } else {
          e.active = i18n.t("inactive")
        }
      })
      setCustomers(ReturnGet3.data.data)
    }
    setLoadingMore(false)
  }
  //TEMPLATE DO HEADER, PARA ADICIONAR FILTRO GLOBAL
  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 10 }}
      >
        <input
          checked={onlyActive}
          onChange={() => {
            setOnlyActive(!onlyActive)
            setOnlyInactive(false)
          }}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 200 }}
      >
        <input
          checked={onlyInactive}
          onChange={() => {
            setOnlyInactive(!onlyInactive)
            setOnlyActive(false)
          }}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>Apenas Inativos</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        value={filter || ""}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  )
  //TEMPLATE PARA FORMATAR DATA DE NASCIMENTO
  const dateBirthTemplate = (data) => {
    return (
      <>
        <span>
          {data.dateBirth && format(new Date(data.dateBirth), "dd/MM/yyyy")}
        </span>
      </>
    )
  }
  //TEMPLATE DOS BOTOES DE AÇÃO
  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        {data && <SendWhatsappMsgToCustomer customer={data} />}
        <Tooltip
          arrow
          title="Empresa integrada ao Open, necessário fazer edições via este sistema"
          disableHoverListener={!data.openId}
        >
          <button
            style={{
              marginRight: 10,
              backgroundColor: "rgba(0,0,0,0)",
              border: 0,
              padding: 0,
            }}
            onClick={() =>
              history.push(`../../dashboard/newcustomer/${data.id}`)
            }
            disabled={Boolean(data.openId)}
          >
            <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
          </button>
        </Tooltip>

        <Tooltip
          arrow
          title="Empresa integrada ao Open, necessário remover via este sistema"
          disableHoverListener={!data.openId}
        >
          <button
            style={{
              marginRight: 10,
              backgroundColor: "rgba(0,0,0,0)",
              border: 0,
              padding: 0,
            }}
            className="action-icon"
            onClick={() => handleInativate(data.id)}
            disabled={Boolean(data.openId)}
          >
            <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
          </button>
        </Tooltip>
      </div>
    )
  }
  //TEMPLATE PARA MOSTRAR IMAGEM NA DATATABLE
  const photoTemplate = (data) => {
    return (
      <img alt={data.name} className="data-table-image" src={data.photo}></img>
    )
  }

  //FILTRAR CLIENTES POR QUALQUER VALOR
  const handleFilter = async (pageNumber, itemsPerPage) => {
    if (filter.length >= 3) {
      setLoadingMore(true)
      getRequest(
        `/customers?CompanyId=${selectedCompany.id}&text=${filter}&onlyActive=${
          onlyActive ? 1 : 0
        }&onlyInactive=${onlyInactive ? 1 : 0}`
      ).then(function (response) {
        if (response.success) {
          response.data.data.forEach((e) => {
            if (e.active) {
              e.active = i18n.t("userActive")
            } else {
              e.active = i18n.t("inactive")
            }
          })
          setPagination({
            ...pagination,
            page: 1,
            offset: 0,
            limit: pagination.rows,
          })
          setCustomers(response.data.data)
          setTotalCustomers(response.data.totalCustomers)
          setLoadingMore(false)
          setLoading(false)
        } else {
          setLoading(false)
          setLoadingMore(false)
        }
      })
    } else if (filter.length === 0) {
      const ReturnGet1 = await getRequest(`/customers/template`)
      if (ReturnGet1.success) {
        setlinkModelo(ReturnGet1.data)
      }
      setLoading(true)
      getRequest(
        `/customers?CompanyId=${selectedCompany.id}&offset=${
          pageNumber ?? pagination.first
        }&limit=${itemsPerPage ?? pagination.rows}&onlyActive=${
          onlyActive ? 1 : 0
        }&onlyInactive=${onlyInactive ? 1 : 0}`
      ).then(function (response) {
        if (response.success) {
          response.data.data.forEach((e) => {
            if (e.active) {
              e.active = i18n.t("userActive")
            } else {
              e.active = i18n.t("inactive")
            }
          })
          setCustomers(response.data.data)
          setPagination({
            ...pagination,
            page: 1,
            offset: 0,
            limit: pagination.rows,
          })
          setFilter("")
          setTotalCustomers(response.data.totalCustomers)
        }
        setLoading(false)
      })
    }
  }

  useEffect(() => {
    if (filter.length < 3 && filter.length !== 0) {
      return
    }
    const timeout = setTimeout(() => {
      handleFilter(0)
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [filter, update, onlyActive, onlyInactive])

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t("attemption"),
      text: i18n.t("eraseClient"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t("confirmEraseCompany"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        //INATIVA USUÁRIO
        const ReturnPut = await putRequest(`/customers/inactivate/${id}`)
        if (ReturnPut.success) {
          setUpdate(update + 1)
        }
      }
    })
  }

  const goBack = () => {
    setShowImportList(false)
    setShowExportList(false)
    setUpdate(update + 1)
  }

  useEffect(() => {
    setLoading(true)
    toggleHelperId(
      !showImportList && !showExportList
        ? 11
        : showExportList && !showImportList
        ? 14
        : 13
    )
  }, [showImportList, showExportList])

  return (
    <>
      <div className="col-12" style={{ overflowY: "auto" }}>
        <div className="card">
          <div className="card-body pt-1">
            {!showImportList && !showExportList ? (
              <>
                <div className="area-header-table-users">
                  <h4>{i18n.t("clients")}</h4>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      style={{ marginRight: 10 }}
                      onClick={() => setShowImportList(true)}
                    >
                      {i18n.t("importClients")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      style={{ marginRight: 10 }}
                      onClick={() => setShowExportList(true)}
                    >
                      {i18n.t("exportClient")}
                    </button>
                    <a
                      href={linkModelo}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      <button
                        type="button"
                        className="btn btn-outline-success"
                        style={{ marginRight: 10 }}
                      >
                        {i18n.t("downloadModel")}
                      </button>
                    </a>
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      style={{ marginRight: 10 }}
                      onClick={() =>
                        history.push(`../../../dashboard/newcustomer`)
                      }
                    >
                      {i18n.t("newClient")}
                    </button>
                  </div>
                </div>
                <div className="tab-content">
                  <div
                    className="tab-pane show active"
                    id="basic-datatable-preview"
                  >
                    {!loading ? (
                      <>
                        <DataTable
                          header={header}
                          dataKey="id"
                          first={0}
                          loading={loadingMore}
                          rows={pagination.rows}
                          rowsPerPageOptions={[50, 100, 150]}
                          value={customers}
                          totalRecords={totalCustomers}
                          emptyMessage={i18n.t("noClientsRegistered")}
                        >
                          <Column
                            body={photoTemplate}
                            header={i18n.t("photo")}
                          ></Column>
                          <Column
                            field="name"
                            header={i18n.t("name")}
                            sortable
                          ></Column>
                          <Column
                            field="document"
                            header={i18n.t("document")}
                          ></Column>
                          <Column
                            body={dateBirthTemplate}
                            field="dateBirth"
                            header={i18n.t("bornDate")}
                          ></Column>
                          <Column
                            field="email"
                            header={i18n.t("email")}
                          ></Column>
                          <Column
                            field="active"
                            header={i18n.t("status")}
                          ></Column>
                          <Column
                            body={actionButtonsTemplate}
                            field="action"
                            header={i18n.t("action")}
                          ></Column>
                        </DataTable>
                        <Paginator
                          page={pagination.page}
                          size={pagination.rows}
                          onPageRecords={customers.length}
                          rowSize={pagination.rows}
                          totalRecords={totalCustomers}
                          itensOnCurrentPage={pagination.rows}
                          pageChange={(pageNumber, itemsPerPage) =>
                            handlePageChange(
                              pageNumber,
                              itemsPerPage ? itemsPerPage : pagination.rows
                            )
                          }
                        />
                      </>
                    ) : (
                      <div className="area-loading">
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                {showExportList ? (
                  <Exports goBack={goBack} />
                ) : (
                  <Imports goBack={goBack} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
